import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import useLocalization from '../../hooks/useLocalization';
import AppModal from '../common/AppModal';
import CircularProgressBar from '../common/circular-progress';
import Logs from './Log';
import { apartmentServices } from '../../services/appartmentServices';

const LogModal = ({ show, onHide, id }) => {
  const [loadingLogs, setLoadingLogs] = useState(false);
  const [logs, setLogs] = useState([]);
  const { translate } = useLocalization();

  const fetchLogs = async () => {
    setLoadingLogs(true);
    let response, error;
    ({ response, error } = await apartmentServices.getApartmentChangeLogs(id));

    setLoadingLogs(false);

    if (error) {
      return toast.error(error);
    }

    setLogs(response);
  };

  useEffect(() => {
    if (show && id) {
      fetchLogs();
    }
  }, [show]);

  return (
    <AppModal show={show} onHide={onHide} title={translate('change_logs')} style={{ zIndex: '9999' }}>
      <div className="p-2">
        {loadingLogs ? (
          <div className="text-center">
            <CircularProgressBar size={4} />
          </div>
        ) : (
          <Logs logs={logs} />
        )}
      </div>
    </AppModal>
  );
};

export default LogModal;
